class PendingGpLettersComponent {
  constructor($scope, $state) {
    Object.assign(this, {
      $scope,
      searchTerm: $state.params.search,
      page: {
        limit: parseInt($state.params.limit),
        offset: (parseInt($state.params.number) - 1) * parseInt($state.params.limit),
      },
    });
  }
}

PendingGpLettersComponent.$inject = ['$scope', '$state', 'GpAddress', 'Print', 'Orders', 'GpLettersService'];
angular.module('pims').controller('PendingGpLetters', PendingGpLettersComponent);

// angular.module('pims').component('pendingGpLetters', {
//   templateUrl: 'app/views/users/gp-letters/tabs/pending-gp-letters/pending-gp-letters.component.html',
//   controller: PendingGpLettersComponent,
//   controllerAs: 'vm',
//   bindings: {}
// })
